import { LoadingController } from 'ionic-angular';
import { Exchange, TopExchange } from './../../models/Exchanges';
import { Coin } from './../../models/Coin';
import { CoinsProvider } from './../../providers/coins/coins';
import { Component, Input, SimpleChanges } from '@angular/core';
import { zip } from 'rxjs/observable/zip';

/**
 * Generated class for the CoinMarketsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-markets',
  templateUrl: 'coin-markets.html'
})
export class CoinMarketsComponent {
  @Input('coin') coin: Coin;
  @Input('currency') currency: string;

  text: string;
  topExchanges: TopExchange[] = [];
  exchanges: Exchange[] = [];

  exchangesNew: [Exchange, TopExchange][] = [];

  showExchange: Exchange = null;
  currencies: string[];
  constructor(
    public CP: CoinsProvider,
    public loadingCtrl: LoadingController
  ) {
    // this.CP.getExchanges().subscribe(exchanges => {
    //   exchanges.getPairsForCoin(this.coin);
    // })
  }

  ngOnInit(){
    this.initExchanges();
  }

  ngOnChanges(changes: SimpleChanges){
    if(!changes.currency.isFirstChange()){
      this.initExchanges();
    }
  }

  private initExchanges(){
    let loader = this.loadingCtrl.create();
    loader.present();
    zip(this.CP.getTopExchanges(this.coin), this.CP.getExchanges())
      .subscribe(vals => {
        this.exchangesNew = [];
        let topExchanges = vals[0];
        let exchanges = vals[1].exchanges;
        this.setExchangesByVol(topExchanges, exchanges);
        loader.dismiss();
      }, error=>{
        console.log(error);
        loader.dismiss();
      })
  }


  toggleExchange(exchange: Exchange){
    if(this.showExchange == exchange){
      this.showExchange = null;
    }else{
      this.showExchange = exchange;
    }
  }

  private setExchangesByVol(topExchanges: TopExchange[], exchanges: Exchange[]){
    let indiciesToRemove = [];

    //Get exchanges that have price/vol data, add them first and get their indicies to remove from list
    for(let top of topExchanges){
      let name = top.name;
      for(let exchange of exchanges){
        if(exchange.name == name){
          this.exchangesNew.push([exchange, top]);
          indiciesToRemove.push(exchanges.indexOf(exchange));

        }
      }
    }

    //Remove exchanges already added
    for(let i of indiciesToRemove){
      exchanges.splice(i, 1);
    }

    //Sort the rest of the exchanges
    exchanges.sort((a, b) => {
      let aName = a.name.toLocaleLowerCase();
      let bName = b.name.toLocaleLowerCase();
      if(aName > bName) return 1;
      if(aName < bName) return -1;
      return 0;
    })

    //Populate the rest of the exchanges without data
    for(let exchange of exchanges){
      this.exchangesNew.push([exchange, null]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/coin-markets/coin-markets.ts